import { HISTORY_LOCATION_CHANGED } from './actions';
import { createReducer } from 'store/createReducer';
import { HistoryChangeAction } from 'store/history/actions';
import { ILocation } from 'models/ILocation';

export const initialState: ILocation = {
  host: '',
  hash: '',
  hostname: '',
  href: '',
  live: true,
  pathname: '/',
  port: '',
  protocol: '',
  search: {}
};

const reducer = {
  [HISTORY_LOCATION_CHANGED]: (state: ILocation, { url, action }: HistoryChangeAction) => {
    return {
      ...state,
      ...url,
      action
    };
  }
};

export default createReducer(initialState, reducer);
